<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 31 31"
    stroke="currentColor"
  >
    <component :is="name" />
  </svg>
</template>

<script>
import Document from "@/icons/Document";
import ArrowNarrowLeft from "@/icons/ArrowNarrowLeft";
import ArrowNarrowRight from "@/icons/ArrowNarrowRight";
import Home from "@/icons/Home";
import Logout from "@/icons/Logout";
import UserGroup from "@/icons/UserGroup";
import ViewGridAdd from "@/icons/ViewGridAdd";
import Fire from "@/icons/Fire";
import Selector from "@/icons/Selector";
import Collection from "@/icons/Collection";
import ClipboardCheck from "@/icons/ClipboardCheck";
import Clock from "@/icons/Clock";
import Trash from "@/icons/Trash";
import Exclamation from "@/icons/Exclamation";
import Blog from "@/icons/Blog";
import Tiktok from "@/icons/Tiktok";
import CurrencyUsd from "@/icons/CurrencyUsd";

export default {
  components: {
    Blog,
    Trash,
    Clock,
    ClipboardCheck,
    Collection,
    Document,
    ArrowNarrowLeft,
    ArrowNarrowRight,
    Home,
    Logout,
    UserGroup,
    ViewGridAdd,
    Fire,
    Selector,
    Exclamation,
    Tiktok,
    CurrencyUsd,
  },
  props: ["name"],
};
</script>

<style></style>
